export default 'announcements'
